import { PluginType, type IExportPlugin } from '@/version-types';
import { EdgelessFusionImagePlugin } from './controller';
import fusionImagePluginState from './state';
import { EdgelessFusionImagePluginView } from './views';

const exportPlugin: IExportPlugin = {
    type: PluginType.STAGE,
    sort: 10,
    name: 'stage-fusion-image',
    render() {
        return <EdgelessFusionImagePluginView />;
    },
    createInstance({ identity }) {
        return [{ key: 'FusionImagePlugin', value: new EdgelessFusionImagePlugin(identity) }];
    },
    createState() {
        return [fusionImagePluginState];
    },
};

export default exportPlugin;
